import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {useHistory} from "react-router-dom";

import Badge from "components/Badge";

import {getDistinctRetailers} from "views/oms/OrderList/utils/getDistinctRetailers";
import {navigateOnClick} from "utils/navigateOnClick";
import {OMSRoutes} from "utils/OMSRoutes";

import {blue700, greyishBlue500} from "assets/jss/main";

RetailerBadgeList.propTypes = {
    orderId: PropTypes.string.isRequired,
    lineItems: PropTypes.arrayOf(PropTypes.shape({
        retailer: PropTypes.shape({
            name: PropTypes.string
        })
    })).isRequired
};

const RetailerBadge = ({retailerName}) => (
    <Badge
        color={'default'}
        size={'large'}
        rounded
        labelSize={14}
        isBold={false}
        labelColor={blue700}
        border
        themeExtension={{padding: {large: '8px'}}}
    >
        {retailerName.length > 14 ? retailerName.substring(0, 14) + '...' : retailerName}
    </Badge>
);

function RetailerBadgeList({orderId, lineItems}) {

    const history = useHistory();

    const retailers = getDistinctRetailers(lineItems);
    const firstThreeRetailers = retailers.slice(0, 3);

    return (
        <div style={{display: 'flex', gap: '4px', flexDirection: 'column', maxWidth:'124px'}}>
            {firstThreeRetailers.map((retailer, index) => (
                <RetailerBadge
                    key={index}
                    retailerName={retailer.name}
                />
            ))}
            {firstThreeRetailers.length < retailers.length && (
               <span
                   style={{
                       color: greyishBlue500,
                       fontSize: '14px',
                       fontWeight: 400,
                       cursor: 'pointer',
                       textDecoration: 'underline',
                   }}
                   onClick={(e) => {
                       e.stopPropagation();
                       navigateOnClick(e, OMSRoutes.ORDER(orderId), history);
                   }}
               >
                   <FormattedMessage id='retailer.product.list.stock.showMore' />
               </span>
            )}
        </div>
    );
}

export default RetailerBadgeList;
